// extracted by mini-css-extract-plugin
export default {"zoomModal":"K3-z"};